// extracted by mini-css-extract-plugin
export default {"circle":"Skeleton_circle__qJ+3m","glow":"Skeleton_glow__4Cm7t","rect":"Skeleton_rect__Ora7s"};